// 新建文件: src/components/hooks/use-expand-state.ts
import { useServices } from '@toeverything/infra';
import { useCallback, useState, useEffect } from 'react';
import { ExpandStateManager } from '../../modules/navigation/services/expand-state-manager';

export function useExpandState(nodeId: string, defaultExpanded = true) {
  const { expandStateManager } = useServices({
    ExpandStateManager,
  });

  const [expanded, setExpanded] = useState(() =>
    expandStateManager.getExpandState(nodeId, defaultExpanded)
  );

  const toggleExpanded = useCallback(() => {
    const newExpanded = !expanded;
    setExpanded(newExpanded);
    expandStateManager.setExpandState(nodeId, newExpanded);
  }, [expanded, nodeId, expandStateManager]);

  const setExpandedState = useCallback(
    (newExpanded: boolean) => {
      setExpanded(newExpanded);
      expandStateManager.setExpandState(nodeId, newExpanded);
    },
    [nodeId, expandStateManager]
  );

  return {
    expanded,
    toggleExpanded,
    setExpanded: setExpandedState,
  };
}
